<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaProd" class="form-label">IdVacunaProd</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaProd" name="idVacunaProd" v-model="datoVacunaProd.idVacunaProd" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idLaboratorio" class="form-label"> Laboratorio</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idLaboratorio" name="idLaboratorio" v-model="datoVacunaProd.idLaboratorio">
                      <option v-for="laboratorio in laboratorios" :value="laboratorio.idLaboratorio" :key="laboratorio.idLaboratorio">
                        {{ laboratorio.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idVacuna" class="form-label"> Vacuna</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idVacuna" name="idVacuna" v-model="datoVacunaProd.idVacuna">
                      <option v-for="vacuna in vacunas" :value="vacuna.idVacuna" :key="vacuna.idVacuna">
                        {{ vacuna.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoVacunaProd.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoVacunaProd.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoVacunaProd.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoVacunaProd.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarVacunaProd" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditVacunaProd" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdVacunaPers</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdVacuna</th>
          <th scope="col">IdVacunaProd</th>
          <th scope="col">IdUsuarioReg</th>
          <th scope="col">IdUsuarioAct</th>
          <th scope="col">FechaApli</th>
          <th scope="col">Observacion</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">Estado</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">VacunaProdNombre</th>
          <th scope="col">VacunaNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vacunapers in datosPaginados" :key="vacunapers.idVacunaPers">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(vacunapers.idVacunaPers)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(vacunapers.idVacunaPers)" title="Editar">edit_square</i></td>
          <td>{{vacunapers.idVacunaPers}}</td>
          <td>{{vacunapers.idPersona}}</td>
          <td>{{vacunapers.idVacuna}}</td>
          <td>{{vacunapers.idVacunaProd}}</td>
          <td>{{vacunapers.idUsuarioReg}}</td>
          <td>{{vacunapers.idUsuarioAct}}</td>
          <td>{{getFormattedDate(vacunapers.fechaApli, 'DD/MM/YYYY')}}</td>
          <td>{{vacunapers.observacion}}</td>
          <td>{{getFormattedDate(vacunapers.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(vacunapers.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{vacunapers.estado}}</td>
          <td>{{getFormattedDate(vacunapers.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{vacunapers.vacunaProdNombre}}</td>
          <td>{{vacunapers.vacunaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteVacunaProd(vacunapers.idVacunaPers)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaPers" class="form-label">IdVacunaPers</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaPers" name="idVacunaPers" v-model="datoVacunaPers.idVacunaPers" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoVacunaPers.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idVacuna" class="form-label"> Vacuna</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idVacuna" name="idVacuna" v-model="datoVacunaPers.idVacuna">
                      <option v-for="vacuna in vacunas" :value="vacuna.idVacuna" :key="vacuna.idVacuna">
                        {{ vacuna.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaProd" class="form-label">IdVacunaProd</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaProd" name="idVacunaProd" v-model="datoVacunaPers.idVacunaProd" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoVacunaPers.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoVacunaPers.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaApli" class="form-label">FechaApli</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaApli" name="fechaApli" v-model="datoVacunaPers.fechaApli" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoVacunaPers.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoVacunaPers.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoVacunaPers.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarVacunaPers" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditVacunaPers" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      vacunaprods : [],
      datoVacunaProd : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idVacunaProd: '',
      laboratorios : [],
      vacunas : [],
// Variables master
// Variables details
      vacunaperss : [],
      datoVacunaPers : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      personas : [],
//      vacunas : [],
      vacunaProds : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idVacunaProd = this.$route.params.p_idvacunaprod
    this.abrirEditar(this.p_idVacunaProd)
    this.getDataPagina(this.paginaActual)
    this.fetchLaboratorios()
    this.fetchVacunas()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idLaboratorio'
        ,'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      const requiredFieldsText = [
        'idLaboratorio'
        ,'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      return validarForm(this.datoVacunaProd, requiredFields, requiredFieldsText);
    },
    async guardarVacunaProd(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunaprods', this.datoVacunaProd)
          swal("Correcto!", "VacunaProd creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditVacunaProd(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunaprods', this.datoVacunaProd)
          swal("Correcto!", "VacunaProd creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoVacunaProd={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idVacunaProd){
      this.modalWindow = true
      if(idVacunaProd != null){    
           api.get('/vwvacunaprods/'+idVacunaProd).then(resp=>{
          this.datoVacunaProd = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarVacunaProd(){
      this.$router.push('/VacunaProd')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.vacunaperss.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwvacunaperss/nombre/'+this.nombreBusqueda).then(response=>{
          this.vacunaperss=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.vacunaperss.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwvacunaperss').then(response=>{
      this.vacunaperss=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.vacunaperss.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idLaboratorio'
        ,'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      const requiredFieldsText = [
        'idLaboratorio'
        ,'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      return validarForm(this.datoVacunaProd, requiredFields, requiredFieldsText);
    },
    async guardarVacunaPers(){
      if(this.validarForm() === 1){
        try {
          this.datoVacunaPers.idVacunaProd = this.datoVacunaProd.idVacunaProd;
          await api.post('/vacunaperss', this.datoVacunaPers)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "VacunaPers creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditVacunaPers(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunaperss', this.datoVacunaPers)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "VacunaPers creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoVacunaPers={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idVacunaPers){
      this.modalWindow = true
      if(idVacunaPers != null){    
           api.get('/vwvacunaperss/'+idVacunaPers).then(resp=>{
          this.datoVacunaPers = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idVacunaPers){
      this.modalWindow = true
      if(idVacunaPers != null){
        this.$router.push('/vacunapersmd/'+idVacunaPers)
      }
    },
    async deleteVacunaPers (idVacunaPers) {
      try{
        await api.delete('/vacunaperss/'+idVacunaPers)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchLaboratorios() {
      fetch('http://localhost:8080/api/v1/laboratorios')
        .then(response => response.json())
        .then(data => {
          this.laboratorios = data;
        })
        .catch(error => {
          console.error('Error fetching laboratorios:', error);
        });
    },
    fetchVacunas() {
      fetch('http://localhost:8080/api/v1/vacunas')
        .then(response => response.json())
        .then(data => {
          this.vacunas = data;
        })
        .catch(error => {
          console.error('Error fetching vacunas:', error);
        });
    },
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
/*     fetchVacunas() {
      fetch('http://localhost:8080/api/v1/vacunas')
        .then(response => response.json())
        .then(data => {
          this.vacunas = data;
        })
        .catch(error => {
          console.error('Error fetching vacunas:', error);
        });
    }, */
    fetchVacunaProds() {
      fetch('http://localhost:8080/api/v1/vacunaprods')
        .then(response => response.json())
        .then(data => {
          this.vacunaProds = data;
        })
        .catch(error => {
          console.error('Error fetching vacunaProds:', error);
        });
    },
  },
}
</script>
